import moment from 'moment';
import { request } from '../../requests';
export default {
  namespaced: true,
  state: {
    items: [],
    cursor: 0,
    loading: false,
    errors: {}
  },
  actions: {
    submit({
      commit
    }, item) {
      const url = `/forms/subjectids/${item.id}/update`;
      const data = {
        ...item
      };
      commit('setLoading', true);
      return request({
        url,
        data
      }).done(responseData => {
        commit('setItem', responseData.result);
      }).always(() => {
        commit('setLoading', false);
      });
    },
    fetch({
      commit,
      getters
    }, {
      projectID
    }) {
      const url = `/tables/projects/${projectID}/subjectids`;
      const data = {
        cursor: getters['cursor']
      };
      const method = 'GET';
      commit('setLoading', true);
      return request({
        url,
        data,
        method
      }).done(responseData => {
        commit('setItems', responseData.result);
        commit('setCursor', responseData.cursor);
        commit('setTimestamp', moment());
      }).always(() => {
        commit('setLoading', false);
      });
    }
  },
  getters: {
    unapprovedItems(state) {
      return state.items.filter(i => i.status === 'Unresolved' || i.status === 'Changes Made - Client Approval Needed').filter(i => i.edited_image_url || i.image_url);
    },
    submittedItems(state) {
      return state.items.filter(i => i.status === 'Submitted - APPROVED' || i.status === 'Submitted - CHANGES REQUESTED').filter(i => i.edited_image_url || i.image_url);
    },
    cursor(state) {
      return state.cursor;
    },
    project(state) {
      return state.project;
    },
    statusText(state) {
      return function (item) {
        if (!item.status) {
          return 'N/A';
        }
        return item.status_text;
      };
    },
    statusColor(state) {
      return function (item) {
        if (item.status === 'Submitted') {
          return 'badge-success';
        }
        return 'badge-secondary';
      };
    },
    errors(state) {
      return state.errors;
    }
  },
  mutations: {
    setItem(state, obj) {
      const item = state.items.find(i => i.id == obj.id);
      if (item) {
        item.status = obj.status;
      }
    },
    setItems(state, items) {
      state.items.push(...items);
    },
    setCursor(state, cursor) {
      state.cursor = cursor;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setTimestamp(state, timestamp) {
      state.timestamp = timestamp;
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    remove(state, item) {
      state.items = state.items.filter(i => i !== item);
    }
  }
};